export interface GradientStop {
    offset: string;
    color: string;
    opacity?: number;
}

export const TIP_BORDER_GRADIENT =
    'linear-gradient(357.8deg, #71DCFF 39.41%, rgba(138, 146, 255, 0.7) 89.42%, rgba(174, 96, 255, 0.3) 139.43%)';

export const CALIBRATION_TRACK_GRADIENT = 'linear-gradient(to right, #01D1D2, #3AC9F3)';
